import { AlertTitle, Box, Typography } from "@mui/material"
import ErrorBox from "../../../../components/shared/boxes/ErrorBox"
import { useState } from "react";

const BillingItemsMessageError = () => {
    const [open, setOpen] = useState(true);
    if (!open) return null;
    return (
        <Box sx={{ my: 2 }}>
            <ErrorBox
                errorMessage={
                    <>
                        <AlertTitle> Detectamos que alguns itens foram alterados após a inclusão na fatura.</AlertTitle>
                        <Typography> Para garantir que as informações estejam atualizadas corretamente na fatura, remova o item e adicione-o novamente antes de continuar. </Typography>
                    </>
                }
                onClose={() => setOpen(false)}
            />
        </Box>
    )
}

export default BillingItemsMessageError;